import React from 'react';
import { Link } from 'react-router';
import '../App.css';
import { useTranslation } from '../contexts/LanguageContext';
import { useGameStore } from '../store/gameStore';
import { LANGUAGE_SETS } from '../utils/constants';

// Import version from package.json
const packageJson = require('../../package.json');

export const LandingPage: React.FC = () => {
  const { selectedLanguageSetId, setSelectedLanguageSetId } = useGameStore();
  const { t } = useTranslation();

  return (
    <div className="App">
      <div className="game-container">
        <h1 className="game-title">KODENAMES</h1>
        <div className="landing-buttons-container">
          <div className="language-selector-container">
            <label className="language-selector-label">
              {t.selectWordPack}
            </label>
            <select 
              value={selectedLanguageSetId}
              onChange={(e) => setSelectedLanguageSetId(e.target.value)}
              className="language-selector"
            >
              {LANGUAGE_SETS.map((languageSet) => (
                <option key={languageSet.id} value={languageSet.id}>
                  {languageSet.name}
                </option>
              ))}
            </select>
          </div>
          
          <Link 
            to="/start-game" 
            className="landing-link-button"
          >
            {t.startNewGame}
          </Link>
          
          <div className="version-info">
            v{packageJson.version}
          </div>
        </div>
      </div>
    </div>
  );
};
